module.exports = __webpack_public_path__ + "img/shibie.52793bf2.svg";